// Copyright © 2026 Qcells. All rights reserved.
//
// This software is proprietary and confidential. Unauthorized use,
// duplication, or distribution of software is strictly prohibited.

import { useMatch, useSearchParams } from 'react-router-dom';

/** Match the explicit site scope consumed by site, alarm and anomaly pages. */
export function useRouteSiteId(): string | null {
  const siteRoute = useMatch('/site/:site_id/*');
  const alarmRoute = useMatch('/alarms/:alarmCode');
  const anomalyRoute = useMatch('/anomalies/:alarmCode');
  const [search] = useSearchParams();

  return siteRoute?.params.site_id ?? (alarmRoute || anomalyRoute ? search.get('site') : null);
}
